export type PlexPostFn = (url: string, data: unknown, options?: Record<string, unknown>) => Promise<any>;
export type PlexNavigateFn = (url: string, data?: unknown, options?: Record<string, unknown>) => void;

export const buildFlowApiCalls = (plexPost: PlexPostFn, plexNavigate: PlexNavigateFn) => ({
  plexFetchDsApi: (searchName: string) => plexPost("/Platform/Flows/SearchDataSource", { Name: searchName }),

  plexFetchDsDetailApi: (id: string) => plexPost("/Platform/Flows/GetDataSourceSchema", { Id: Number(id) }),

  adhocRunFlow: (request: unknown) => plexPost("/Platform/Flows/AdhocRun", request),

  navigateToDataSourcePage: (data: unknown, openNewTab: boolean) => {
    const options: Record<string, unknown> = openNewTab ? { newWindow: true } : {};
    plexNavigate(data === null ? "/Platform/CustomerDataSourceManager" : "/Platform/CustomerDataSourceManager/Form", data, options);
  },

  plexGetTraceEntries: (executionId: string, offset: number, limit: number) =>
    plexPost("/Platform/Flows/GetTraceEntries", { executionId, offset, limit }, { showOverlay: false }),

  plexGetTraceSnapshots: (executionId: string, entryIndexes: number[]) =>
    plexPost("/Platform/Flows/GetSnapshots", { executionId, entryIndexes }, { showOverlay: false }),

  plexSearchCustomObjects: (name: string, customFieldsOnly: boolean) =>
    plexPost("/Platform/Flows/SearchCustomObject", { Name: name, CustomFieldsOnly: customFieldsOnly }),

  plexSearchStandardObjects: (friendlyName: string, customFieldsOnly: boolean) =>
    plexPost("/Platform/Flows/SearchStandardObject", { FriendlyName: friendlyName, CustomFieldsOnly: customFieldsOnly }),

  plexGetCustomFieldsSchema: (standardObjectId: string, standardObjectFriendlyName: string) =>
    plexPost("/Platform/Flows/GetCustomFieldsSchema", {
      StandardObjectId: standardObjectId,
      StandardObjectFriendlyName: standardObjectFriendlyName
    }),

  plexGetNodeMetadata: (nodeType: string, data: unknown) =>
    plexPost("/Platform/Flows/GetNodeMetadata", { NodeType: nodeType, Data: data }),

  plexSearchPlexEvents: (eventTopicName: string, tags: string[]) =>
    plexPost("/Platform/Flows/SearchPlexEvent", { EventTopicName: eventTopicName, Tags: tags }),

  plexSearchPlexActions: (eventTopicId: string, actionTitle: string | null) =>
    plexPost("/Platform/Flows/SearchPlexAction", { EventTopicId: eventTopicId, ActionTitle: actionTitle }),

  plexSearchPlexApplicationActions: (eventTopicId: string, actionTitle: string | null) =>
    plexPost("/Platform/Flows/SearchPlexApplicationAction", { EventTopicId: eventTopicId, ActionTitle: actionTitle }),

  plexSearchPlexOpenApi: (searchName: string) => plexPost("/Platform/Flows/SearchPlexOpenApi", { Name: searchName }),

  plexSearchMlModel: (searchName: string) => plexPost("/Platform/Flows/SearchMlModel", { Name: searchName }),

  plexSearchExternalApiEndpoint: (endpointGroupId: string | null, endpointName: string | null) =>
    plexPost("/Platform/Flows/SearchEndpoint", { EndpointGroupId: endpointGroupId, EndpointName: endpointName }),

  plexSearchPlexAgents: (agentName: string | null) =>
    plexPost("/Platform/Flows/SearchPlexAgents", { AgentName: agentName }),

  navigateToPlexAgentPage: (data: { Name: string; } | null, openNewTab: boolean) => {
    const options: Record<string, unknown> = openNewTab ? { newWindow: true } : {};
    let url: string;
    if (!data || !data.Name) {
      url = "/Platform/AI/Agents/ViewAgentsGrid";
    }
    else {
      url = "/Platform/AI/AgentCustomers/ViewAgentCustomer";
    }
    plexNavigate(url, data, options);
  }
});
